/**
 * Stable CSS class names for E2E — ShippingPerformance page.
 * Containers use `shipping-performance__<element>`; inputs and
 * user-interactable controls use `shipping-performance-input--<name>`.
 */
export const SPERF = {
    page: 'shipping-performance-page',
    root: 'shipping-performance',

    header: 'shipping-performance__header',
    title: 'shipping-performance__title',

    controls: 'shipping-performance__controls',
    controlsRow: 'shipping-performance__controls-row',
    performanceValueBox: 'shipping-performance__performance-value-box',
    performanceValue: 'shipping-performance__performance-value',
    sliderBox: 'shipping-performance__slider-box',
    inputSlider: 'shipping-performance-input--performance-slider',
    costValueBox: 'shipping-performance__cost-value-box',
    costValue: 'shipping-performance__cost-value',
    actionBox: 'shipping-performance__action-box',
    btnSave: 'shipping-performance-input--button-save',

    summary: 'shipping-performance__summary',
    summaryCard: 'shipping-performance__summary-card',
    summaryGrid: 'shipping-performance__summary-grid',
    summaryLabel: 'shipping-performance__summary-label',
    summaryValue: 'shipping-performance__summary-value',
    summaryCostRate: 'shipping-performance__summary-value--cost-rate',
    summaryPerformanceRate: 'shipping-performance__summary-value--performance-rate',
    summaryUpdatedBy: 'shipping-performance__summary-value--updated-by',
    summaryUpdatedDate: 'shipping-performance__summary-value--updated-date',
} as const;

export const sperfCls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');
